module.exports = __webpack_public_path__ + "img/logout.b3c93439.svg";